import { render } from "./waste_type.vue?vue&type=template&id=36a8f054"
import script from "./waste_type.vue?vue&type=script&lang=js"
export * from "./waste_type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__